import { render } from "./pill.vue?vue&type=template&id=873c6b84&ts=true"
import script from "./pill.ts?vue&type=script&lang=ts"
export * from "./pill.ts?vue&type=script&lang=ts"

import "./pill.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__